import TotalsSummaryContainer from './totals_summary_container';

const TotalsSummary = TotalsSummaryContainer;
export default TotalsSummary;
